<template>
  <v-list>
    <v-list-item>
      <v-list-item-content>
        <div>
          <v-row>
            <v-col cols="12">
              <div class="d-flex align-center justify-end">
                <v-btn color="primary" @click="actionCreate">
                  <v-icon>mdi-plus</v-icon>Walkin Product Order
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <v-row class="d-flex align-center justify-end">
            <v-col cols="12" sm="6" md="4" lg="3" xl="2">
              <DatePickerWrapperInputMenu
                label="Start Date"
                outlined
                v-model="searchTime.start"
                clearable
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" xl="2">
              <DatePickerWrapperInputMenu
                label="End Date"
                outlined
                v-model="searchTime.end"
                clearable
              />
            </v-col>
          </v-row>
        </div>
      </v-list-item-content>
    </v-list-item>
    <v-list-item>
      <v-list-item-content>
        <v-row>
          <v-col cols="1">
            <b>Date</b>
          </v-col>
          <v-col cols="1">
            <b>Transaction ID</b>
          </v-col>
          <v-col cols="1">
            <b>Product ID</b>
          </v-col>
          <v-col cols="3">
            <b>Description</b>
          </v-col>
          <v-col cols="1">
            <b>Quantity</b>
          </v-col>
          <v-col cols="1">
            <b>Marked Price </b>
          </v-col>
          <v-col cols="1">
            <b>Selling Price</b>
          </v-col>
          <v-col cols="1">
            <b>Sub total</b>
          </v-col>
          <v-col cols="1">
            <b>Payment</b>
          </v-col>
          <v-col cols="1"></v-col>
        </v-row>
        <v-divider />
      </v-list-item-content>
    </v-list-item>
    <v-list-item v-for="item in list">
      <v-list-item-content>
        <v-row style="word-break: break-word">
          <v-col cols="1">
            {{ item.purchased_at | moment('YYYY/MM/DD hh:mm') }}
          </v-col>
          <v-col cols="1">
            {{ get(item, 'transaction.sid') }}
          </v-col>
          <v-col cols="1">
            {{ item.product.sid }}
          </v-col>
          <v-col cols="3">
            {{ item.product.name }}
          </v-col>
          <v-col cols="1">
            {{ item.qty }}
          </v-col>
          <v-col cols="1">
            {{ item.product.listedPrice | toThousandFilter }}
          </v-col>
          <v-col cols="1">
            {{ item.product.discountedPrice | toThousandFilter }}
          </v-col>
          <v-col cols="1">
            {{ item.subtotal | toThousandFilter }}
          </v-col>
          <v-col cols="1">
            <span>{{ item.paymentStatus | status }}{{ item.bookingStatus | status }}</span>
            <span class="red--text" v-if="item.isVoided">(Void)</span>
          </v-col>
          <v-col cols="1"><v-btn @click="show(item)">Show Detail</v-btn></v-col>
          <!-- <v-col cols="2">{{ item.created_at | moment('YYYY/MM/DD hh:mm') }}</v-col>
          <v-col cols="2">{{ item.sid }}</v-col>
          <v-col cols="1">{{ item.amountPayable | toThousandFilter }}</v-col>
          <v-col cols="1">{{ item.paymentMethod }}</v-col>
          <v-col cols="1">{{ item.paymentStatus }}</v-col>
          <v-col cols="1"
            >{{ item.status | status }}
            <span style="color: red">
              {{ item.isVoided ? '(Voided)' : '' }}
            </span></v-col
          >
          <v-col cols="2" v-if="!isMaster">{{ get(item, 'items[0].commission.to.name') }}</v-col>
          <v-col cols="1"><v-btn @click="show(item._id)">Show Detail</v-btn></v-col> -->
        </v-row>
        <v-divider />
      </v-list-item-content>
    </v-list-item>
    <v-list-item v-if="!list || !list.length" class="text-center">
      <v-row>
        <v-col> No Data </v-col>
      </v-row>
    </v-list-item>
    <v-pagination class="mt-4" v-model="pageVal" :total-visible="10" :length="data.pages || 1" />
    <ProductOrderEditDialog
      v-model="editDialog"
      :id="editId"
      :defaultProfile="id"
      :productCategories="productCategories"
      @create="reload"
      @update="reload"
      @delete="reload"
    />
  </v-list>
</template>

<script>
import api from '@/api';
import { crudList } from '@/api/crud';
import { RESTFUL } from '@/data/constants';
import { get } from 'lodash';
import { fetchPurchasedProducts } from '@/api/physicalProductOrder';
import { paymentStatus } from '@/data/constants';
import { BookingStatus } from '@/api/bookings';
import DatePickerWrapperInputMenu from '@/components/DatePickerWrapperInputMenu';
import { getOid } from '@/services/utils';
import ProductOrderEditDialog from '@/components/PhysicalProductOrder/ProductOrderEditDialog';
import { listProductCategories } from '@/api/productCategory';
import moment from 'moment';

export default {
  components: {
    DatePickerWrapperInputMenu,
    ProductOrderEditDialog,
  },
  name: 'IdentityPurchasedProductsList',
  props: {
    id: {},
    isMaster: Boolean,
    isVoided: Boolean,
  },
  data() {
    return {
      paymentStatus,
      BookingStatus,
      list: [],
      data: {},
      page: 1,
      searchTime: {
        start: null,
        end: null,
      },

      productCategories: [],
      editId: null,
      editDialog: false,
    };
  },
  computed: {
    pageVal: {
      get() {
        return this.page;
      },
      set(val) {
        this.page = val;
        this.reload();
      },
    },
  },
  watch: {
    id: {
      immediate: true,
      handler(v) {
        if (v) {
          this.reload();
        }
      },
    },
    searchTime: {
      handler(v) {
        this.reload();
      },
      deep: true,
    },
  },
  mounted() {
    this.getProductCategories();
  },
  methods: {
    get,
    show(item) {
      if (item.isBookings) {
        this.$emit('showBooking', getOid(item));
      } else if (item.isPhysicalProductOrders) {
        this.$emit('showPhysicalProductOrder', getOid(item));
      }
    },
    async reload() {
      try {
        const query = {
          filter: {
            // $or: [
            //   // for physicalProduct
            //   { paymentStatus: paymentStatus.paid },
            //   // for Booking
            //   { bookingStatus: BookingStatus.completed },
            // ],
            $and: [],
          },
          sort: { purchased_at: -1 },
          limit: 5,
          page: this.page,
        };
        if (this.searchTime.start) {
          query.filter.$and.push({
            created_at: { $gte: moment(this.searchTime.start).startOf('d') },
          });
        }
        if (this.searchTime.end) {
          query.filter.$and.push({
            created_at: { $lte: moment(this.searchTime.end).endOf('d') },
          });
        }

        if (this.isMaster) {
          query.filter['items[0].commission.to'] = this.id;
        } else {
          query.filter.created_by = this.id;
        }
        this.data = await fetchPurchasedProducts(api, query);
        this.list = this.data.docs;
      } catch (e) {
        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: e,
        });
      }
    },
    async getProductCategories() {
      this.productCategories = await listProductCategories(api);
    },
    actionCreate() {
      this.editDialog = true;
    },
  },
};
</script>

<style scoped></style>
